export default "__VITE_ASSET__2qgic09J__"